import React, { Fragment } from 'react';
import { Box, Stack, Grid, Table, TableHead, TableBody, TableCell, TableRow, Tooltip, RadioGroup, Radio, MenuItem, Badge, IconButton, Collapse, FormLabel, Typography } from '@mui/material';
import { StyledCard, StyledCardTitle, StyledTableContainer, TableBadge, CustomRadio, StyledDataGrid, DataGridProps, CustomInputLabel, CustomDatePicker, InputProps, CustomSelect, SelectInputProps, FlexDiv, CustomButton } from '../../../../../custom/components';
import styles from '../../../../../custom/style.module.css';
import contractStyles from './contracts.module.css';
import { JSONTree } from 'react-json-tree';
import { AttachFile as AttachFileIcon, KeyboardArrowDown, KeyboardArrowUp, Comment, DragIndicator, PostAdd } from '@mui/icons-material';
import { AddIcon, DateFormat, DeleteIcon, DollarRateIcon, EditIcon, jsonTheme } from '../../../../../custom/constants';
import AddContractItem from './AddContractItem';
import AddNonCommercialItem from './AddNonCommercialItem';
import DocModalContainer from 'components/pages/common/docModal/DocModalContainer';
import EditActiveContract from './EditActiveContract';
import moment from 'moment';
import { dateTolocale } from 'utils/converter';
import dayjs from 'dayjs';
import cookies from 'utils/cookies';
import EncryptionContainer from 'components/pages/common/EncryptionContainer';
import Status from 'components/pages/common/Status';
import { DndContext, closestCenter } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';
import {
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import RemarkModal from 'components/pages/common/RemarkModal';

function SortableTableRow({ id, detail, rate, item, props, type, j }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({
    id,
    detail,
    rate,
    item,
    props,
    j,
    type
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    cursor: 'grab',
  };

  return (

    <TableRow ref={setNodeRef} style={style} {...attributes} {...listeners}
      className={`${j === item.contractrows.length - 1 ? `${contractStyles.lastRow} ${contractStyles.rowEnd}` : j === 0 ? `${contractStyles.lastRow} ${contractStyles.rowStart}` : contractStyles.lastRow} ${contractStyles.collapsedTableRow}`}
    >
      <TableCell classes={{ root: `${contractStyles.collapsedTableCell} ${styles.p0}` }} width={'6%'}></TableCell>
      <TableCell classes={{ root: `${contractStyles.collapsedTableCell}` }}>
        <Tooltip title='Drag to rearrange order'>
          <IconButton size='small'>
            <DragIndicator fontSize='inherit' />
          </IconButton>
        </Tooltip>
      </TableCell>

      <TableCell classes={{ root: `${contractStyles.collapsedTableCell}` }}>
        <span>{detail?.description}</span>
      </TableCell>
      {type == 'contrates' ?
        cookies.get('ismanagec') && cookies.get('ismanagec') == 'true' && cookies.get('managecdt') && moment(cookies.get('managecdt')).isAfter(moment()) &&
        <TableCell classes={{ root: ` ${contractStyles.collapsedTableCell}` }}>{rate?.tier
          ? <Stack direction={'row'}><div className={contractStyles.tieredRate}>{`${cookies.get('currency')} ${Number(rate?.rate?.toString().replace(',', '')).toLocaleString('en-US', {
            minimumFractionDigits: 3,
            maximumFractionDigits: 3
          })}`} </div> &nbsp;
            |<div className={contractStyles.tieredNo}>{` Tier ${rate?.tier} `}</div>| &nbsp;
          <div className={contractStyles.tieredLevel}>{` ${rate?.level || '-'}`}</div> </Stack>
          : `${cookies.get('currency')} ${Number(rate?.rate?.toString().replace(',', '')).toLocaleString('en-US', {
            minimumFractionDigits: 3,
            maximumFractionDigits: 3
          })}`
        }</TableCell> :
        props.tab == 'active' ?
          cookies.get('ismanagec') && cookies.get('ismanagec') == 'true' && cookies.get('managecdt') && moment(cookies.get('managecdt')).isAfter(moment()) &&
          <TableCell classes={{ root: ` ${contractStyles.collapsedTableCell}` }}><i>{detail.refparent ? `linked to ${detail.refparent.description}` : '-'}</i></TableCell>
          : ''
      }
      <TableCell classes={{ root: `${contractStyles.collapsedTableCell}` }}>
        <div>{detail?.applied_on?.includes('Auto') ?
          <span style={{ paddingLeft: '40px' }}>-</span> : detail?.roles && detail?.roles[0] === 'N/A' ? <span style={{ paddingLeft: '32px' }}>{detail?.roles[0]}</span> :
            detail?.roles?.length > 0 && detail?.roles?.join(', ')}
        </div>
      </TableCell>
      <TableCell classes={{ root: `${contractStyles.collapsedTableCell}` }}>{detail?.applied_on ? detail?.applied_on.split('|')[0] : ''}</TableCell>
      <TableCell classes={{ root: `${contractStyles.collapsedTableCell}` }}>{detail?.applied_on ? detail?.applied_on.split('|')[1] : ''}</TableCell>
      {detail.is_nonbillable === true || detail.is_noncommercial === true ?
        <TableCell classes={{ root: `${contractStyles.collapsedTableCell}` }}></TableCell>
        : type == 'contrates' ?
          cookies.get('ismanagec') && cookies.get('ismanagec') == 'true' && cookies.get('managecdt') && moment(cookies.get('managecdt')).isAfter(moment()) &&
          <TableCell classes={{ root: ` ${contractStyles.collapsedTableCell}` }}><div>{detail?.is_minimum ? ((cookies.get('currency') + detail?.minimum) || (cookies.get('currency') + '0')) : 'N/A'}</div></TableCell>
          :
          props.tab == 'active' ?
            cookies.get('ismanagec') && cookies.get('ismanagec') == 'true' && cookies.get('managecdt') && moment(cookies.get('managecdt')).isAfter(moment()) &&
            <TableCell classes={{ root: ` ${contractStyles.collapsedTableCell}` }}>{'N/A'}</TableCell> :
            ''
      }

      <TableCell classes={{ root: `${contractStyles.collapsedTableCell}` }}>{type == 'contrates' ? detail?.platform : 'N/A'}</TableCell>
      {detail.is_nonbillable === true || detail.is_noncommercial === true ?
        <TableCell classes={{ root: `${contractStyles.collapsedTableCell}` }}></TableCell> :
        <TableCell classes={{ root: `${contractStyles.collapsedTableCell}` }}>{detail?.record_on || 'N/A'}</TableCell>
      }
      <TableCell classes={{ root: `${contractStyles.collapsedTableCell}` }}>{detail?.segment || 'N/A'}</TableCell>

      <TableCell onPointerDown={(e) => e.stopPropagation()} classes={{ root: `${contractStyles.collapsedTableCell} ${contractStyles.commentIconCell} ` }} align='center'>
        {detail?.remarks ? <Badge color='secondary' variant='dot'>
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              props.handleRemark('remark', detail?.remarks);
            }}
            className={`${styles.p0}`}
            size='small'
            color='primary'>
            <Comment fontSize='inherit' />
          </IconButton>
        </Badge>
          : <IconButton
            className={`${styles.p0}`}
            size='small'
            disabled
          >
            <Comment fontSize='inherit' />
          </IconButton>
        }
      </TableCell>
      {props.tab == 'active' &&
        // cookies.get('ismanagec') && cookies.get('ismanagec') == 'true' && cookies.get('managecdt') && moment(cookies.get('managecdt')).isAfter(moment()) &&
        (<TableCell onPointerDown={(e) => e.stopPropagation()} classes={{ root: ` ${contractStyles.collapsedTableCell}` }} className={contractStyles.lastRowAction}><Stack direction='row' spacing={2} justifyContent='center' className={`${styles.actionIcons} ${contractStyles.smallIcon}`}>
          {(cookies.get('ismanagec') && cookies.get('ismanagec') == 'true' && cookies.get('managecdt') && moment(cookies.get('managecdt')).isAfter(moment())) && (!detail?.is_nonbillable || detail?.is_nonbillable == false) && (!detail.is_noncommercial || detail.is_noncommercial !== true) ?
            <EditIcon
              onClick={(e) => {
                e.stopPropagation();
                props.handleOpen('contract_item', 'edit', item, detail);
              }}
            /> : null
          }
          {/* { cookies.get('isnoncomapprover') && cookies.get('isnoncomapprover') == 'true' && detail?.is_nonbillable ? */}
          {detail?.is_nonbillable || detail.is_noncommercial === true ?
            <>
              <> </>
              <EditIcon
                title='Edit Statistics Item'
                onClick={(e) => {
                  e.stopPropagation();
                  props.handleOpen('commercial_item', 'edit', item, detail);
                }}
              />
            </> : null
          }
          {
            (cookies.get('ismanagec') && cookies.get('ismanagec') == 'true' && cookies.get('managecdt') && moment(cookies.get('managecdt')).isAfter(moment())) ?
              (type == 'contrates' ?
                <DeleteIcon onClick={(e) => { props.handleDelete('contrate', rate.id, detail, e.target); }} /> :
                <DeleteIcon onClick={(e) => { props.handleDelete('controw', detail.id, detail, e.target); }} />)
              : (detail?.is_nonbillable || detail?.is_nonbillable == true || detail.is_noncommercial === true) ?
                (type == 'contrates' ?
                  <DeleteIcon onClick={(e) => { props.handleDelete('contrate', rate.id, detail, e.target); }} /> :
                  <DeleteIcon onClick={(e) => { props.handleDelete('controw', detail.id, detail, e.target); }} />)
                : null
          }
        </Stack>
        </TableCell>
        )}
    </TableRow>
  );
}

const ManageContracts = (props) => {
  const exclude_keys = ['id', 'createdAt', 'updatedAt', 'companyId', 'contractId', 'productId', 'deleted', 'airlineId', 'stationId'];

  const filterObject = (obj1, obj2) => {
    let result = [];
    for (const key in obj1) {
      if (exclude_keys.includes(key)) continue;
      if (obj1[key] !== obj2[key]) {
        if (Array.isArray(obj1[key]) && Array.isArray(obj2[key])) {
          let arr = [];
          obj1[key].forEach((item, i) => {
            arr.push(filterObject(item, obj2[key][i]));
          });
          if (arr.length > 0)
            result.push({
              key,
              value: arr
            });
        } else if (Array.isArray(obj1[key])) {
          let arr = [];
          obj1[key].forEach((item) => {
            arr.push(filterObject(item, {}));
          }
          );
          if (arr.length > 0)
            result.push({
              key,
              value: arr
            });
        } else {
          result.push({
            key,
            value: obj1[key],
            prev_value: obj2[key]
          });
        }
      }
    }
    return result;
  };

  const renderObject = (obj1, obj2) => {
    return (<div>
      {filterObject(obj1, obj2).map((item, i) => {
        if (item.key == 'start_date' || item.key == 'end_date') {
          item.value = moment(item.value).format(DateFormat);
          item.prev_value = moment(item.prev_value).format(DateFormat);
        }
        // check if item.value is not empty object
        if (item.value && Array.isArray(item.value) && item.value.length > 0 && !typeof item.value === 'object') {
          return (
            <div key={i}>
              <b>{item.key}</b>&rarr;
              <div>{item.value.map((iitem, ii) => {
                if (iitem.length > 1) {
                  return (
                    <div key={ii}>
                      &nbsp;&nbsp;&nbsp;<b>{iitem[0]?.key}&rarr; {iitem[0]?.prev_value || 'NA'}&rarr; {iitem[0]?.value}</b>
                    </div>
                  );
                }
              })}</div>
            </div>
          );
        } else if (typeof item.value === 'object') {
          //do nothing 

        }
        else {
          return (
            <div key={i}>
              <b>{item.key}&rarr; {item.prev_value || 'NA'}&rarr; {item.value}</b>
            </div>
          );
        }
      })}
    </div>);
  };

  const mapObject = (obj1) => {
    let result = {};
    for (const key in obj1) {
      if (exclude_keys.includes(key)) continue;
      if ((key == 'start_date' || key == 'end_date') && obj1[key])
        obj1[key] = moment(obj1[key]).format(DateFormat);
      if (Array.isArray(obj1[key])) {
        let arr = [];
        obj1[key].forEach((item) => {
          arr.push(mapObject(item, {}));
        }
        );
        if (arr.length > 0)
          result[key] = arr;
      } else {
        result[key] = obj1[key];
      }
    }
    return result;
  };

  const getTabs = () => {

    let tabs = [
      {
        label: 'Active',
        value: 'active'
      },
      {
        label: 'Expired',
        value: 'expired',
      },
      {
        label: 'Complex Drivers',
        value: 'complexDrivers'
      }
    ];
    if (cookies.get('ismanagec') && cookies.get('ismanagec') == 'true' && cookies.get('managecdt') && moment(cookies.get('managecdt')).isAfter(moment())) {
      tabs.push({
        label: 'Logs',
        value: 'logs'
      }
      );

    }
    return tabs.map((value, index) => {
      return <Fragment key={index}>
        <CustomRadio value={value.value}
          control={<Radio className={styles.radioToggleBtn} />}
          label={value.label}
          className={`${styles.radioToggle} ${props.tab === value.value ? styles.radioToggleBtnChecked : ''}`}
          classes={{ label: styles.radioToggleLabel }}
        />
      </Fragment>;
    });
  };

  const columns = [
    {
      field: 'created',
      headerName: 'Date & Time',
      minWidth: 150,
      flex: 0.8,
      renderCell: ({ row }) => dateTolocale(row.created, 'DD MMM YYYY HH:mm')
    },
    {
      field: 'type',
      headerName: 'Type',
      minWidth: 150,
      flex: 0.8,
    },
    {
      field: 'operation',
      headerName: 'Operation',
      minWidth: 150,
      flex: 0.8,
    },
    {
      field: 'prev_details',
      headerName: 'Previous Details',
      minWidth: 100,
      flex: 1.5,
      renderCell: ({ row }) => (
        <>
          {row?.prev_details ? <JSONTree data={mapObject(row?.prev_details)}
            theme={{
              ...jsonTheme,
              tree: ({ style }) => ({
                style: {
                  ...style,
                  backgroundColor: 'transparent'
                },
                className: 'myTreeClassName'
              }),
            }}
            invertTheme={true} className='json-tree' /> : 'N/A'}
        </>
      )
    },
    {
      field: 'new_details',
      headerName: 'New Details',
      minWidth: 100,
      flex: 1,
      renderCell: ({ row }) => row?.new_details ? renderObject(row?.new_details, row?.prev_details || {}) : 'N/A'
    },
    {
      field: 'user',
      headerName: 'User',
      minWidth: 100,
      flex: 1,
      renderCell: ({ row }) => row?.user?.first_name + ' ' + row?.user?.last_name
    },
  ];

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <StyledCard>
          <FlexDiv><StyledCardTitle>Contracts</StyledCardTitle></FlexDiv>
          <Grid container spacing={3}>
            <Grid item container xs={12} mt={'-24px'}>
              <Grid item xs xl ml={'130px'} className={styles.fMiddle}>
                <RadioGroup
                  aria-labelledby='contract-type-radio-buttons-group'
                  name='contract-type-radio-buttons-group'
                  // value={contractType}
                  value={props.tab}
                  row
                  onChange={props.onChangeTab}
                  className={styles.radioToggleGroup}
                // className={props.userContractTypes.length > 0 ? `${styles.radioTabContainer} ${styles.radioTabContainerJustifty}` : ''}
                >
                  {getTabs()}
                </RadioGroup>
              </Grid>
              <Grid item xs='auto'>
                <Stack direction='row' alignItems={'center'} justifyContent='flex-end' spacing={2}>
                  <FormLabel component='small' className={`${styles.xsW100}`}><small>Filter:</small> </FormLabel>
                  <CustomSelect
                    {...SelectInputProps}
                    id='airline'
                    labelId='airline-label'
                    fullWidth
                    autoFocus
                    onChange={props.onChange}
                    name='airline'
                    // className={billingStyles.tableTextField}
                    style={{ width: '90px' }}
                    value={!props.searchFields.airline ? 'placeholder' : props.searchFields.airline}
                    classes={{ select: !props.searchFields.airline ? styles.colorPlaceholder : '' }}
                  >
                    <MenuItem value='placeholder' disabled>Airline</MenuItem>
                    <MenuItem value='All'>All</MenuItem>
                    {props?.airlines?.map((airline, i) => (
                      <MenuItem key={i} value={airline.id}>
                        {airline.code}
                      </MenuItem>
                    ))}
                  </CustomSelect>
                  {
                    cookies.get('ismanagec') && cookies.get('ismanagec') == 'true' && !cookies.get('managecdt') &&
                    <DollarRateIcon title='Secure Billing Access'
                      className={styles.mr0}
                      onClick={() => props.tab == 'active' && props.handleOpen('encryption', null, null, null)} disabled={props.tab != 'active'} />
                  }
                  {
                    // if user is managec and managecdt && managecdt > current date time
                    cookies.get('ismanagec') && cookies.get('ismanagec') == 'true' && cookies.get('managecdt') && moment(cookies.get('managecdt')).isAfter(moment()) &&
                    <AddIcon title='Add Contract' onClick={() => props.tab == 'active' && props.handleOpen('contract', 'add', null, null)} disabled={props.tab != 'active'} />
                  }
                  <IconButton disableRipple title='Assign to Complex Driver'
                    onClick={() => props.tab == 'complexDrivers' && props.handleOpen('complexDrivers', null, null, null)} className={styles.p0}
                    disabled={props.tab != 'complexDrivers'}
                    classes={{
                      root: `${styles.sqIcons} ${styles.my0}`,
                      disabled: `${styles.disabledImg} ${styles.my0}`
                    }}
                  >
                    <PostAdd fontSize='inherit' />
                  </IconButton>
                </Stack>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              {props.tab && ['active', 'expired'].includes(props.tab) && (
                <StyledTableContainer className={contractStyles.collapsibleTableContainer}>
                  <Table aria-label='collapsible table' className={contractStyles.collapsibleTable}>
                    <TableHead className={contractStyles.collapsibleTableHead}>
                      <TableRow className={contractStyles.collapsibleHeadRow}>
                        <TableCell className={`${contractStyles.collapsibleTableCell}`} />
                        <TableCell className={`${contractStyles.collapsibleTableCell}`}>Airline Code</TableCell>
                        <TableCell className={`${contractStyles.collapsibleTableCell}`}>Department</TableCell>
                        {cookies.get('ismanagec') && cookies.get('ismanagec') == 'true' && cookies.get('managecdt') && moment(cookies.get('managecdt')).isAfter(moment()) &&
                          <TableCell className={`${contractStyles.collapsibleTableCell}`}>Contract Min</TableCell>
                        }
                        {/* <TableCell>Billing Email</TableCell> */}
                        <TableCell className={`${contractStyles.collapsibleTableCell}`}>Start Date</TableCell>
                        <TableCell className={`${contractStyles.collapsibleTableCell}`}>End Date</TableCell>
                        {cookies.get('ismanagec') && cookies.get('ismanagec') == 'true' && cookies.get('managecdt') && moment(cookies.get('managecdt')).isAfter(moment()) &&
                          <TableCell align='center' className={`${contractStyles.collapsibleTableCell}`}>Attachment</TableCell>
                        }
                        {(props.tab == 'active' || props.tab == 'expired') &&
                          // cookies.get('ismanagec') && cookies.get('ismanagec') == 'true' && cookies.get('managecdt') && moment(cookies.get('managecdt')).isAfter(moment()) &&
                          (<TableCell align='center' className={`${contractStyles.collapsibleTableCell}`}>Add</TableCell>)}
                        <TableCell align='center' className={`${contractStyles.collapsibleTableCell}`}>Action</TableCell>
                      </TableRow>
                      <TableRow className={contractStyles.collapsedTableRow}>
                        <TableCell colSpan={props.tab == 'active' &&
                          cookies.get('ismanagec') && cookies.get('ismanagec') == 'true' && cookies.get('managecdt') && moment(cookies.get('managecdt')).isAfter(moment()) ? 14 : 10} className={contractStyles.headerBlock}></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className={contractStyles.collapsibleTableBody}>
                      {props?.filteredData?.map((item, i) => (
                        <Fragment key={i}>
                          <TableRow classes={{ root: `${contractStyles.collapsibleTableRow} ${contractStyles.collapsibleTableRowSticky}` }} >
                            <TableCell className={contractStyles.collapsibleTableCell} width={50}>
                              <IconButton
                                aria-label='expand row'
                                size='small'
                                onClick={() => props.handleTableCollapse(item.id)}
                                disabled={item.contractrows.length == 0}
                              >
                                {props.collapse?.includes(item.id) ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                              </IconButton>
                            </TableCell>
                            <TableCell className={`${contractStyles.collapsibleTableCell}`}>
                              <div>{item.airline?.code}</div>
                            </TableCell>
                            <TableCell className={`${contractStyles.collapsibleTableCell}`}>
                              <span className={styles.department}>{item.type}</span>
                            </TableCell>
                            {cookies.get('ismanagec') && cookies.get('ismanagec') == 'true' && cookies.get('managecdt') && moment(cookies.get('managecdt')).isAfter(moment()) &&
                              <TableCell className={`${contractStyles.collapsibleTableCell}`}>
                                <div>{item.is_minimum ? cookies.get('currency') + (item.minimum || 0) : 'N/A'}</div>
                              </TableCell>
                            }
                            <TableCell className={`${contractStyles.collapsibleTableCell}`}>
                              <div>{moment(item?.start_date).format(DateFormat).toUpperCase()}</div>
                            </TableCell>
                            <TableCell className={`${contractStyles.collapsibleTableCell}`}>
                              <div>{moment(item?.end_date).format(DateFormat).toUpperCase()}</div>
                            </TableCell>
                            {cookies.get('ismanagec') && cookies.get('ismanagec') == 'true' && cookies.get('managecdt') && moment(cookies.get('managecdt')).isAfter(moment()) &&
                              <TableCell align='center' className={`${contractStyles.collapsibleTableCell}`}>
                                <div className={`${styles.pointer} ${contractStyles.attachIcon}`}
                                  onClick={() => props.handleDoc(item)}>
                                  <Tooltip title='Add/View Attachment'>
                                    <TableBadge color='error' badgeContent={item?.docs?.length} sx={{ position: 'absolute' }}>
                                      <AttachFileIcon fontSize='small' />
                                    </TableBadge>
                                  </Tooltip>
                                </div>
                              </TableCell>
                            }
                            <TableCell align='center' className={`${contractStyles.collapsibleTableCell}`}>
                              <Stack direction='row' spacing={1} justifyContent='center' >
                                {props.tab == 'active' &&
                                  cookies.get('ismanagec') && cookies.get('ismanagec') == 'true' && cookies.get('managecdt') && moment(cookies.get('managecdt')).isAfter(moment()) &&
                                  (
                                    <CustomButton variant='contained' className={contractStyles.statButton} onClick={() => props.handleOpen('contract_item', 'add', item)}>Add Billable</CustomButton>
                                  )}
                                <div></div>
                                {props.tab == 'active' && <CustomButton variant='contained' className={contractStyles.statButton} onClick={() => props.handleOpen('commercial_item', 'add', item)}>Add Statistics</CustomButton>}
                              </Stack>
                            </TableCell>
                            <TableCell width={80} classes={{ root: contractStyles.contractAction }} className={`${contractStyles.collapsibleTableCell}`}>
                              <div>
                                {props.tab == 'active' &&
                                  cookies.get('ismanagec') && cookies.get('ismanagec') == 'true' && cookies.get('managecdt') && moment(cookies.get('managecdt')).isAfter(moment()) &&
                                  <Stack direction='row' spacing={2} justifyContent='flex-end' className={`${styles.actionIcons} ${contractStyles.smallIcon}`} mr={'8px'}>
                                    <EditIcon onClick={() => props.handleOpen('active_contract', 'edit', item, null)} />
                                    <DeleteIcon onClick={(e) => { props.handleDelete('contract', item.id, item, e.target); }} disabled={item.contractrows && item.contractrows.length > 0} />
                                  </Stack>}
                                {props.tab == 'expired' &&
                                  cookies.get('ismanagec') && cookies.get('ismanagec') == 'true' && cookies.get('managecdt') && moment(cookies.get('managecdt')).isAfter(moment()) &&
                                  <Stack direction='row' spacing={2} justifyContent='flex-end' className={`${styles.actionIcons} ${contractStyles.smallIcon}`} mr={'8px'}>
                                    <EditIcon onClick={() => props.handleOpen('active_contract', 'edit', item, null)} />
                                  </Stack>}
                              </div>
                            </TableCell>
                          </TableRow>
                          <TableRow classes={{ root: contractStyles.collapsibleTableRow }} sx={{
                            '& > *': { borderBottom: 'unset' },
                            height: 20
                          }}>
                            <TableCell colSpan={props.tab == 'active' &&
                              cookies.get('ismanagec') && cookies.get('ismanagec') == 'true' && cookies.get('managecdt') && moment(cookies.get('managecdt')).isAfter(moment()) ?
                              14 : 10} className={contractStyles.collapsibleTableCellMain}>
                              <Collapse in={props.collapse?.includes(item.id)} timeout='auto' unmountOnExit>
                                <Box>
                                  <DndContext collisionDetection={closestCenter} onDragEnd={(event) => props.handleDragEnd(event, item.contractrows)}>
                                    <SortableContext
                                      items={item.contractrows.map((detail) => detail?.id)}
                                      strategy={verticalListSortingStrategy}
                                    >
                                      {/* Billable Table */}
                                      <Typography variant='body2' className={contractStyles.tableTitle}>Billing</Typography>
                                      <Table aria-label='' className={contractStyles.collapsedTable}>
                                        {item.contractrows && item.contractrows.length > 0 &&
                                          <TableHead className={contractStyles.collapsedTableHead}>
                                            <TableRow className={contractStyles.collapsedTableRow}>
                                              <TableCell className={`${styles.p0} ${contractStyles.emptyCollapsedTableCell}`}></TableCell>
                                              <TableCell className={contractStyles.collapsedTableCell}></TableCell>
                                              <TableCell className={contractStyles.collapsedTableCell}>Item</TableCell>
                                              {
                                                cookies.get('ismanagec') && cookies.get('ismanagec') == 'true' && cookies.get('managecdt') && moment(cookies.get('managecdt')).isAfter(moment()) &&
                                                <TableCell className={contractStyles.collapsedTableCell} width={120}>Rate</TableCell>
                                              }
                                              <TableCell className={contractStyles.collapsedTableCell} width={80}>Role</TableCell>
                                              <TableCell className={contractStyles.collapsedTableCell} width={150}>Applied Per</TableCell>
                                              <TableCell className={contractStyles.collapsedTableCell} width={80}>Input</TableCell>
                                              {cookies.get('ismanagec') && cookies.get('ismanagec') == 'true' && cookies.get('managecdt') && moment(cookies.get('managecdt')).isAfter(moment()) &&
                                                <TableCell className={contractStyles.collapsedTableCell} width={90}>Line Min</TableCell>
                                              }
                                              <TableCell className={contractStyles.collapsedTableCell} width={100}>Platform</TableCell>
                                              <TableCell className={contractStyles.collapsedTableCell} width={200}>Record On</TableCell>
                                              <TableCell className={contractStyles.collapsedTableCell} width={100}>Segment</TableCell>
                                              <TableCell className={contractStyles.collapsedTableCell} align='center' width={90}>Remarks</TableCell>
                                              {props.tab == 'active' &&
                                                <TableCell className={contractStyles.collapsedTableCell} width={80}>Action</TableCell>
                                              }
                                            </TableRow>
                                          </TableHead>
                                        }
                                        <TableBody className={contractStyles.collapsedTableBody}>
                                          <TableRow className={`${styles.mb3} ${styles.dBlock} ${contractStyles.spacingRowStart}`}></TableRow>
                                          {item.contractrows && item.contract_height > 0 && item.contractrows.filter(detail => (!detail?.is_nonbillable || detail?.is_nonbillable == false)).map((detail, j) => (
                                            <Fragment key={'row' + j}>
                                              {detail.contrates && detail.contrates.length > 0 ?
                                                detail?.contrates.map((rate) => (
                                                  <SortableTableRow key={rate.id} id={detail?.id} detail={detail} rate={rate} item={item} props={props} type={'contrates'} j={j} />
                                                ))
                                                :
                                                <SortableTableRow key={detail.id} id={detail?.id} detail={detail} item={item} props={props} type={'linked'} j={j} />
                                              }
                                            </Fragment>
                                          ))}
                                          <TableRow className={`${styles.mb3} ${styles.dBlock} ${contractStyles.spacingRow}`}></TableRow>
                                        </TableBody>
                                      </Table>
                                      {/* Non Billable Table */}
                                      {item.contractrows && item.contract_height > 0 && item.contractrows.filter(detail => detail.is_nonbillable === true || detail.is_noncommercial === true).length > 0 &&
                                        <>
                                          <Typography variant='body2' className={contractStyles.tableTitle}>Statistics</Typography>
                                          <Table aria-label='' className={contractStyles.collapsedTable}>
                                            <TableHead className={contractStyles.collapsedTableHead}>
                                              <TableRow className={contractStyles.collapsedTableRow}>
                                                <TableCell className={`${styles.p0} ${contractStyles.emptyCollapsedTableCell}`}></TableCell>
                                                <TableCell className={contractStyles.collapsedTableCell}></TableCell>
                                                <TableCell className={contractStyles.collapsedTableCell}>Item</TableCell>
                                                {
                                                  cookies.get('ismanagec') && cookies.get('ismanagec') == 'true' && cookies.get('managecdt') && moment(cookies.get('managecdt')).isAfter(moment()) &&
                                                  <TableCell className={contractStyles.collapsedTableCell} width={120}>Rate</TableCell>
                                                }
                                                <TableCell className={contractStyles.collapsedTableCell} width={80}>Role</TableCell>
                                                <TableCell className={contractStyles.collapsedTableCell} width={150}>Applied Per</TableCell>
                                                <TableCell className={contractStyles.collapsedTableCell} width={80}>Input</TableCell>
                                                <TableCell className={contractStyles.collapsedTableCell} width={90}></TableCell>
                                                <TableCell className={contractStyles.collapsedTableCell} width={100}>Platform</TableCell>
                                                <TableCell className={contractStyles.collapsedTableCell} width={200}></TableCell>
                                                <TableCell className={contractStyles.collapsedTableCell} width={100}>Segment</TableCell>
                                                <TableCell className={contractStyles.collapsedTableCell} align='center' width={90}>Remarks</TableCell>
                                                <TableCell className={contractStyles.collapsedTableCell} width={80}>Action</TableCell>
                                              </TableRow>
                                            </TableHead>
                                            <TableBody className={contractStyles.collapsedTableBody}>
                                              <TableRow className={`${styles.mb3} ${styles.dBlock} ${contractStyles.spacingRowStart}`}></TableRow>
                                              {item.contractrows && item.contract_height > 0 && item.contractrows.filter(detail => detail.is_nonbillable === true || detail.is_noncommercial === true).map((detail, j) => (
                                                <Fragment key={'row' + j}>
                                                  <SortableTableRow key={detail.id} id={detail?.id} detail={detail} item={item} props={props} type={'linked'} j={j} />
                                                </Fragment>
                                              ))}
                                              <TableRow className={`${styles.mb3} ${styles.dBlock} ${contractStyles.spacingRow}`}></TableRow>
                                            </TableBody>
                                          </Table>
                                        </>
                                      }
                                    </SortableContext>
                                  </DndContext>
                                </Box>
                              </Collapse>
                            </TableCell>
                          </TableRow>

                        </Fragment>
                      ))}
                    </TableBody>
                  </Table>
                </StyledTableContainer>
              )}

              {props.tab == 'logs' && (
                <Grid container spacing={3}>
                  <Grid item container spacing={2} columnSpacing={4}>
                    <Grid item xs={12} sm={6} md={3} lg={2} xl={2}>
                      <CustomInputLabel htmlFor='' aria-label='Enter From Date'>From</CustomInputLabel>
                      <CustomDatePicker
                        slotProps={{
                          textField: {
                            ...InputProps,
                            placeholder: 'From Date',
                            fullWidth: true
                          },
                        }}
                        className={styles.w100}
                        format='DD MMM YYYY'
                        name='from'
                        value={dayjs(moment(props.searchOptions.from, 'YYYY MM DD'))}
                        // helperText={}
                        onChange={(e) => props.handleSearchOption(e, 'from')}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} lg={2} xl={2}>
                      <CustomInputLabel htmlFor='' aria-label='Enter To Date'>To</CustomInputLabel>
                      <CustomDatePicker
                        slotProps={{
                          textField: {
                            ...InputProps,
                            placeholder: 'To Date',
                            fullWidth: true
                          },
                        }}
                        className={styles.w100}
                        format='DD MMM YYYY'
                        name='to'
                        value={dayjs(moment(props.searchOptions.to, 'YYYY MM DD'))}
                        // helperText={}
                        onChange={(e) => props.handleSearchOption(e, 'to')}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <div className={styles.tableWrapper}>
                      <Box className={`${styles.tableOuter} ${contractStyles.contractLogTableOuter}`}>
                        <StyledDataGrid
                          {...DataGridProps}
                          rows={props.logs || []}
                          columns={columns}
                          classes={{
                            root: contractStyles.contractLogTable,
                            cell: contractStyles.contractLogTableCell,
                            row: contractStyles.contractLogTableRow,
                          }}
                          param={props.logs?.length}
                        />
                      </Box>
                    </div>
                  </Grid>
                </Grid>
              )}
              {props.tab == 'complexDrivers' && (
                <StyledTableContainer className={contractStyles.collapsibleTableContainer}>

                </StyledTableContainer>
              )}
            </Grid>
          </Grid>
        </StyledCard>

        <EncryptionContainer
          functionCall={props.fetchContract}
          startTimer={props.startTimer}
          stopInterval={props.stopInterval}
          handleOpen={props.handleOpen}
          modal={props.modal}
          onClose={props.onClose}
        />

        <Status
          statusModal={props.sessionExpired}
          onClose={props.onClose}
          statusMessage={{
            type: 'warning',
            size: 'md',
            title: 'Session Expired',
            mainMessage: 'Session Expired',
            firstMessage: 'Please authenticate again to restart the session.',
            secondMessage: ''
          }}
        />

        <AddContractItem
          modal={props.modal}
          action={props.action}
          onClose={props.onClose}
          airline={props.airline}
          checklist={props.checklist}
          checklistField={props.checklistField}
          checklistErrors={props.checklistErrors}
          addChecklist={props.addChecklist}
          editChecklist={props.editChecklist}
          onChangeChecklist={props.onChangeChecklist}
          products={props.products}
          accessories={props.accessories}
          recordOns={props.recordOns}
          segments={props.segments}
          controwField={props.controwField}
          contrateField={props.contrateField}
          onChangecontrowField={props.onChangecontrowField}
          onChangecontrateField={props.onChangecontrateField}
          addControw={props.addControw}
          editControw={props.editControw}
          deleteContrate={props.deleteContrate}

          controwErrors={props.controwErrors}
          contrateErrors={props.contrateErrors}

          anchorEl={props.anchorEl}
          handlePopover={props.handlePopover}
          attachment={props.attachment}
          handleNumberFormat={props.handleNumberFormat}
          handleOnFocus={props.handleOnFocus}
          dropdown_contracts={props.dropdown_contracts}
          buildUp={props.buildUp}
          appliedOn={props.appliedOn}
          handleRadioChange={props.handleRadioChange}
        />

        <EditActiveContract
          modal={props.modal}
          action={props.action}
          onClose={props.onClose}
          addContract={props.addContract}
          editContracts={props.editContracts}
          airlines={props.airlines}
          contractFieldEdit={props.contractFieldEdit}
          contractErrorsEdit={props.contractErrorsEdit}
          onChangecontractFieldEdit={props.onChangecontractFieldEdit}
          onChangechangeDateAndTime={props.onChangechangeDateAndTime}
        />

        <AddNonCommercialItem
          modal={props.modal}
          action={props.action}
          onClose={props.onClose}
          airline={props.airline}
          checklist={props.checklist}
          checklistField={props.checklistField}
          checklistErrors={props.checklistErrors}
          addChecklist={props.addChecklist}
          editChecklist={props.editChecklist}
          onChangeChecklist={props.onChangeChecklist}
          products={props.products}
          accessories={props.accessories}
          recordOns={props.recordOns}
          segments={props.segments}
          controwField={props.controwField}
          contrateField={props.contrateField}
          onChangecontrowField={props.onChangecontrowField}
          onChangecontrateField={props.onChangecontrateField}
          addControw={props.addControw}
          editControw={props.editControw}
          deleteContrate={props.deleteContrate}

          controwErrors={props.controwErrors}
          contrateErrors={props.contrateErrors}

          anchorEl={props.anchorEl}
          handlePopover={props.handlePopover}
          attachment={props.attachment}
          handleNumberFormat={props.handleNumberFormat}
          handleOnFocus={props.handleOnFocus}
          dropdown_contracts={props.dropdown_contracts}
          buildUp={props.buildUp}
          appliedOn={props.appliedOn}
          handleRadioChange={props.handleRadioChange}
          commercial_options={props.commercial_options}
          commercial_items={props.commercial_items}
          handleCustomMultiSelect={props.handleCustomMultiSelect}
          nonCommOpts={props.nonCommOpts}
        />

        <DocModalContainer />

        {
          props.modal === 'remark' &&
          <RemarkModal
            modal={props.modal}
            onClose={props.onClose}
            remark={props.modalData}
          />
        }

      </Grid>
    </Grid>
  );
};

export default ManageContracts;


